import { render, staticRenderFns } from "./ucgoods.vue?vue&type=template&id=d70a9700&scoped=true"
import script from "./ucgoods.vue?vue&type=script&lang=js"
export * from "./ucgoods.vue?vue&type=script&lang=js"
import style0 from "./ucgoods.vue?vue&type=style&index=0&id=d70a9700&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70a9700",
  null
  
)

export default component.exports